module.exports = __webpack_public_path__ + "img/account_personalcard.dec89967.svg";